<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 35 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0924 21.8687H30.2243M19.0924 21.8687C19.0924 24.944 21.5832 27.4348 24.6584 27.4348M19.0924 21.8687C19.0924 18.7934 21.5832 16.3026 24.6584 16.3026M30.2243 21.8687C30.2243 24.944 27.7336 27.4348 24.6584 27.4348M30.2243 21.8687C30.2243 18.7934 27.7336 16.3026 24.6584 16.3026M24.6584 27.4348C23.5035 27.4348 22.5712 24.944 22.5712 21.8687C22.5712 18.7934 23.5035 16.3026 24.6584 16.3026M24.6584 27.4348C25.8133 27.4348 26.7456 24.944 26.7456 21.8687C26.7456 18.7934 25.8133 16.3026 24.6584 16.3026M19.7743 5.17038H16.0033C15.3632 5.17038 14.8066 5.60175 14.6536 6.22098L13.9578 9.00403C13.8535 9.42149 13.9439 9.85982 14.2083 10.2007C14.4727 10.5417 14.8762 10.7365 15.3076 10.7365H15.6137M4.94099 19.5866L5.87328 14.9111H6.87516C7.30652 14.9111 7.71005 14.7162 7.97443 14.3753C8.23882 14.0344 8.32927 13.5961 8.2249 13.1786L7.52916 10.3956C7.37609 9.77633 6.8195 9.34496 6.17941 9.34496H1.2118M13.5613 21.66C7.91876 22.8288 2.3876 19.2039 1.21875 13.5543C0.0498986 7.90473 3.68169 2.38037 9.33113 1.21845C14.9806 0.0495693 20.4978 3.68841 21.6597 9.338M19.0924 12.128H30.2243C30.2243 12.128 33.0073 12.128 33.0073 14.9111V30.2178C33.0073 30.2178 33.0073 33.0009 30.2243 33.0009H19.0924C19.0924 33.0009 16.3095 33.0009 16.3095 30.2178V14.9111C16.3095 14.9111 16.3095 12.128 19.0924 12.128Z"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.25 7.69862C22.25 4.25149 25.0444 1.45703 28.4914 1.45703C31.9385 1.45703 34.7329 4.25149 34.7329 7.69862C34.7329 11.1458 31.9385 13.9402 28.4914 13.9402C25.0444 13.9402 22.25 11.1458 22.25 7.69862ZM30.8025 6.53732C30.9567 6.32155 30.9067 6.02169 30.6909 5.86756C30.4752 5.71344 30.1753 5.76342 30.0212 5.97919L27.9501 8.87885L26.9105 7.83925C26.723 7.65175 26.419 7.65175 26.2315 7.83925C26.044 8.02674 26.044 8.33074 26.2315 8.51824L27.6718 9.95861C27.7716 10.0584 27.9103 10.1092 28.0509 10.0976C28.1916 10.086 28.32 10.013 28.402 9.89818L30.8025 6.53732Z"
      fill="#539F73"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 64,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
